import { createSlice } from '@reduxjs/toolkit'
import { fetchPhaseday } from '../../../application/usecases/fetchPhaseday.ts'

interface PhasedayState {
  data: any | null
  loading: boolean
  error: string | null
}

const initialState: PhasedayState = {
  data: null,
  loading: false,
  error: null,
}

const phasedaySlice = createSlice({
  name: 'phaseday',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPhaseday.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchPhaseday.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload
      })
      .addCase(fetchPhaseday.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Error desconocido'
      })
  },
})

export default phasedaySlice.reducer
